import React from 'react';

const SiteSelector = ({ sites, selectedSite, onChange, loading, noMargin }) => {
  const containerStyle = {
    marginBottom: noMargin ? '0' : '24px'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '8px'
  };

  const selectWrapperStyle = {
    position: 'relative',
    maxWidth: '400px'
  };

  const selectStyle = {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    fontWeight: '500',
    border: '2px solid var(--border)',
    borderRadius: '8px',
    background: 'var(--surface)',
    color: 'var(--text-primary)',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    appearance: 'none',
    paddingRight: '40px'
  };

  const iconStyle = {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    color: 'var(--text-secondary)',
    fontSize: '12px'
  };

  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={labelStyle}>Loading sites...</div>
      </div>
    );
  }

  if (!sites || sites.length === 0) {
    return (
      <div style={containerStyle}>
        <div style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>
          No sites available
        </div>
      </div>
    );
  }

  if (sites.length === 1) {
    const site = sites[0];
    const displayName = site.name || site.site_name;
    const locationInfo = site.location || site.city;
    
    return (
      <div style={containerStyle}>
        <label style={labelStyle}>Active Site</label>
        <div style={{ ...selectStyle, paddingRight: '16px', cursor: 'default' }}>
          {displayName} {locationInfo ? `- ${locationInfo}` : ''}
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>
        Select Site {sites.length > 1 && `(${sites.length} total)`}
      </label>
      <div style={selectWrapperStyle}>
        <select
          value={selectedSite}
          onChange={(e) => onChange(Number(e.target.value))}
          style={selectStyle}
          onFocus={(e) => {
            e.target.style.borderColor = 'var(--primary)';
            e.target.style.boxShadow = '0 0 0 3px var(--primary-light)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = 'var(--border)';
            e.target.style.boxShadow = 'none';
          }}
        >
          {sites.map(site => (
            <option key={site.id} value={site.id}>
              {site.name || site.site_name} {site.location || site.city ? `- ${site.location || site.city}` : ''}
            </option>
          ))}
        </select>
        <span style={iconStyle}>▼</span>
      </div>
    </div>
  );
};

export default SiteSelector;